import { locatedInUStoForeignIndicator, convertAddressType } from '@/utils'

export default {
  methods: {
    getMemberPayload(context) {
      return {
        clientHealthId: context.clientId,
        transactionId: context.transaction ? context.transaction.transactionId : context.transactionId,
        subscriberCk: '', // not relivant for primary subscribers
        subscriberMemberCk: '', // not relivant for primary subscribers
        fileBoundId: context.fileBoundId,
        memberFirstName: context.firstName,
        memberLastName: context.lastName,
        memberMidInitial: context.middleInitial,
        memberNameSuffix: context.suffix,
        memberDateOfBirth: context.dob,
        ssn: context.ssn,
        gender: context.gender,
        relationship: context.relationship,
        phone: context.contactInformation.phone,
        email: context.contactInformation.email,
        memberIdSource: '', // waiting for answer
        eyemedMemberId: context.eyemedMemberId,
        primaryAddress: {
          line1: context.contactInformation.line1,
          line2: context.contactInformation.line2,
          line3: context.contactInformation.line3,
          city: context.contactInformation.city,
          state: context.contactInformation.state,
          zip: context.contactInformation.zip,
          foreignIndicator: locatedInUStoForeignIndicator(context.contactInformation.locatedInUS, context.contactInformation.foreignIndicator),
          county: context.contactInformation.county,
          type: convertAddressType(context.contactInformation)
        },
        coverage: {
          groupCk: context.groupCk,
          subGroupCk: context.subGroupCk,
          classId: context.classId,
          planId: context.planId,
          startDate: context.effectiveDate,
          endDate: context.termDate
        },
        reportingCodes: this.mapReportingCodes(context),
        privacy: this.mapPrivacy(context),
        ...this.mapLanguageAssistance(context)
      }
    },
    mapLanguageAssistance(context) {
      return {
        ethnicity: {
          code: context.languageAssistance.ethnicity,
          description: ''
        },
        race: {
          code: context.languageAssistance.race,
          description: ''
        },
        spokenLanguage: {
          code: context.languageAssistance.spokenLanguage,
          description: ''
        },
        writtenLanguage: {
          code: context.languageAssistance.writtenLanguage,
          description: ''
        }
      }
    },
    mapPrivacy(context) {
      return {
        firstName: context.privacyAddress.firstName,
        midInitial: context.privacyAddress.middleInitial || context.privacyAddress.midInitial,
        lastName: context.privacyAddress.lastName,
        address: {
          line1: context.privacyAddress.line1,
          line2: context.privacyAddress.line2,
          line3: context.privacyAddress.line3,
          city: context.privacyAddress.city,
          state: context.privacyAddress.state,
          zip: context.privacyAddress.zipCode,
          county: context.privacyAddress.county,
          foreignIndicator: locatedInUStoForeignIndicator(context.privacyAddress.locatedInUS, context.privacyAddress.foreignIndicator)
        }
      }
    },
    mapReportingCodes(context) {
      let reportingCodes = []
      const reportingCodeFieldCount = 5
      for (let i = 1; i <= reportingCodeFieldCount; ++i) {
        const fieldVal = context.reportingCodes[`reportingCode${i}`] || ''

        reportingCodes.push(fieldVal)
      }

      return {
        divisionCode: context.reportingCodes.divisionCode,
        benefitOption: context.reportingCodes.benefitOption,
        locationGroupNumber: context.reportingCodes.locationCode,
        companyCode: context.reportingCodes.companyCode,
        clientGroupNumber: context.reportingCodes.clientGroupNumber,
        reportingCodes: reportingCodes
      }
    }
  }
}
